// extracted by mini-css-extract-plugin
export default {"container":"Heading_container__3JLLk","txt-date":"Heading_txt-date__gUMGR","txt-day":"Heading_txt-day__OkHhA"};